import styled from "styled-components";
import {Device} from "@/store/Device";

export const NumberTable = styled.table`
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%;
    font-family: sans-serif;
    text-align: right;
    font-size: 14px;

    &.small {
        font-size: ${Device.isMobile ? '10px' : '12px'};
    }

    thead {
        background-color: #f0f0f0;
        text-align: center;
    }

    th,
    td {
        padding: 6px;
        border: 1px solid #ddd;
    }

    &.small td {
        padding: 4px 2px;
    }

    thead th:first-child {
        border-top-left-radius: 4px;
    }

    thead th:last-child {
        border-top-right-radius: 4px;
    }

    tbody tr:last-child td:first-child {
        border-bottom-left-radius: 4px;
    }

    tbody tr:last-child td:last-child {
        border-bottom-right-radius: 4px;
    }

    tbody tr:hover {
        background-color: #fafafa;
    }

    tr.carry {
        background-color: #f8eed1;
    }

    tr.sub-total {
        background-color: #d1e3f4;
    }

    tr.total {
        background-color: #fae9df;
    }

    td.nobr {
        white-space: nowrap;
    }
`;